export default __webpack_public_path__ + "static/media/bg09.629c244e.png";